import {
  eventShownNameType,
  eventType,
  singleRecord,
} from '../../common/types';
import { FC, memo, useEffect, useState } from 'react';
import '../../App.css';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Button,
  Box,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

import {
  calcPoint,
  calcPointForSort,
  calcPointToJSXForSort,
} from '../functions/calcPointForResult';
import { UpDownIcon } from '@chakra-ui/icons';
import { createEventShownData } from '../functions/createScoreData';
import { eventNameDict } from '../functions/eventNameDict';
import { approximatePointButton } from './approximatePointButton';
import { shownResult } from '../functions/shownResult';
import { IntroductionModal } from './IntroductionModal';
import { eventNameDictEn } from '../functions/eventNameDictEn';
import { shownResultEn } from '../functions/shownResultEn';
import { IntroductionModalEn } from './IntroductionModalEn';
import { nameDictEn } from '../functions/nameDictEn';

export const ResultEventTableEn: FC<{
  Event: eventType;
  Data: singleRecord[];
  csbData: singleRecord[];
  cpbData: singleRecord[];
  sbData: singleRecord[];
  pbData: singleRecord[];
}> =
  // memo(
  ({ Event, Data, csbData, cpbData, sbData, pbData }) => {
    const [currentSort, setCurrentSort] =
      useState<eventShownNameType>('result');
    // 表示させるためのデータ作成する
    const showData = Data.map((D, i) =>
      createEventShownData(
        Event,
        D,
        !!sbData[i] ? sbData[i] : sbData[0],
        !!pbData[i] ? pbData[i] : pbData[0],
        !!csbData[i] ? csbData[i] : csbData[0],
        !!cpbData[i] ? cpbData[i] : cpbData[0]
      )
    );
    const [data, setData] = useState(showData);
    const rank = Object.keys(data);
    const titles = Object.keys(showData[0]) as eventShownNameType[];
    const [clickName, setClickName] = useState('');
    const filledProfileNameList = Data.filter((f) => !!f['name']).map(
      (f) => f.name
    );
    const { isOpen, onOpen, onClose } = useDisclosure();

    //　データを取得した際にソートさせる
    useEffect(() => {
      setData(
        showData.slice().sort((a, b) => {
          return calcPoint(Event, a.result) > calcPoint(Event, b.result)
            ? -1
            : 1;
        })
      );
    }, [Data, csbData, cpbData, sbData, pbData]);

    // ソートボタンの実装
    const sortButton = (title: eventShownNameType) => {
      if (['name'].includes(title)) {
        return <>NAME</>;
      }
      return (
        <Button size="xs" onClick={() => handlePointChange(title)}>
          {eventNameDictEn(title)}
          <UpDownIcon />
        </Button>
      );
    };
    const handlePointChange = (title: eventShownNameType) => {
      let newData = [...showData];
      setCurrentSort(title);
      const sortData = newData.sort((a, b) => {
        return calcPointForSort(title, Event, a[title]) >
          calcPointForSort(title, Event, b[title])
          ? -1
          : 1;
      });
      setData(sortData);
    };

    const handleNameClick = (NAME: string) => () => {
      setClickName(NAME);
      onOpen();
    };

    return (
      <>
        <IntroductionModalEn
          isOpen={isOpen}
          onClose={onClose}
          todayData={Data}
          CSB={csbData}
          CPB={cpbData}
          SB={sbData}
          PB={pbData}
          Name={clickName}
        />
        <Box ml="1" fontFamily="monospace" position="relative" zIndex="40">
          {eventNameDictEn(Event)}　　Swipe records to see more
          {/* 　　　　{approximatePointButton(Event)} */}
        </Box>
        <TableContainer>
          <Table size="sm" width="1">
            <TableCaption>DecathlonResult</TableCaption>
            <Thead>
              <Tr>
                <Th textAlign={'center'}>
                  Rank
                  <br />
                  {/* {eventNameDictEn(currentSort)} */}
                </Th>

                {titles.map((title: eventShownNameType, i) => {
                  return (
                    <Th key={i} textAlign={'center'}>
                      {sortButton(title)}
                    </Th>
                  );
                })}
              </Tr>
            </Thead>
            <Tbody>
              {data.map((singledata, i) => {
                return (
                  <Tr key={i}>
                    <Td textAlign={'center'}>{Number(rank[i]) + 1}</Td>
                    <Td textAlign={'center'}>
                      {(() => {
                        // まず辞書から英語表記を取得（無ければそのまま）
                        const enName =
                          nameDictEn[singledata.name] || singledata.name;

                        // 「名前-国名」に分割
                        const [fullName, country] = enName.split('-');

                        // 「・」で名前を分割（カタカナ対応）
                        const nameParts = fullName.split('・');
                        const firstName = nameParts[0] || '';
                        const lastName = nameParts[1] || '';

                        return (
                          <>
                            {/* ファーストネーム */}
                            <Text
                              fontSize={'9pt'}
                              fontWeight={'bold'}
                              color={'#4169e1'}
                              onClick={handleNameClick(singledata.name)}
                            >
                              {firstName}
                            </Text>

                            {/* ラストネーム */}
                            {(filledProfileNameList.includes(
                              singledata.name
                            ) && (
                              <Text
                                fontSize={'9.5pt'}
                                fontWeight={'bold'}
                                color={'#4169e1'}
                                onClick={handleNameClick(singledata.name)}
                              >
                                {lastName}
                              </Text>
                            )) || (
                              <Text fontSize={'9.5pt'} fontWeight={'bold'}>
                                {lastName}
                              </Text>
                            )}

                            {/* 国名 */}
                            <Text fontSize={'7pt'} color={'GrayText'}>
                              {country || 'なし'}
                            </Text>
                          </>
                        );
                      })()}
                    </Td>

                    {Object.entries(singledata).map((row, i) => {
                      const kiroku = row[1];
                      const point = calcPointToJSXForSort(
                        row[0],
                        Event,
                        row[1]
                      );
                      if (row[0] === 'name') {
                        return null;
                      }
                      return (
                        <Td key={i} textAlign={'center'}>
                          {shownResultEn(kiroku, row[0])}
                          <br />
                          {point}
                        </Td>
                      );
                    })}
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </TableContainer>
      </>
    );
  };
// )
